<!-- More icon trigger for Group Notes -->
<sh-icon
  icon="more"
  class="row-action-icon more-trigger"
  button
  [id]="'group-notes-more-' + groupIndex"
  (click)="toggleNotesMenu()"
  (keydown)="toggleNotesMenu()">
</sh-icon>
<sh-tooltip
  delay
  [target]="'group-notes-more-' + groupIndex"
  [label]="'filter-criteria.tooltip.moreActions' | translate"
  placement="top"
  variation="short">
</sh-tooltip>

<!-- Overlays moved to document.body to escape the sticky group-header stacking context -->
<div #overlayHost class="notes-overlay-host">

<!-- Group Notes actions popover -->
<sh-popover
  *ngIf="showNotesMenu"
  [visible]="true"
  [target]="'group-notes-more-' + groupIndex"
  position="bottom-left"
  position-fixed-adjustment
  always-stay-within
  class="group-notes-menu"
  style="z-index: 100010;">

  <sh-menu-item
    label="Add note"
    (click)="onAddNote(); closeNotesMenu()"
    (keydown)="onAddNote(); closeNotesMenu()">
  </sh-menu-item>
 <sh-divider></sh-divider>
  <sh-menu-item
    label="Duplicate group without Notes"
    (click)="onDuplicateWithoutNotes(); closeNotesMenu()"
    (keydown)="onDuplicateWithoutNotes(); closeNotesMenu()">
  </sh-menu-item>

  <sh-divider></sh-divider>

  <sh-menu-item
    label="Delete group"
    (click)="onDeleteGroup(); closeNotesMenu()"
    (keydown)="onDeleteGroup(); closeNotesMenu()">
  </sh-menu-item>

</sh-popover>

<!-- Group Note card (floating) -->
<sh-card
  *ngIf="showNoteCard"
  class="note-card"
  [class.note-card--fullscreen]="isNoteFullscreen"
  [style.top.px]="!isNoteFullscreen ? cardTop : null"
  [style.right.px]="!isNoteFullscreen ? cardRight : null"
  [label]="groupName || 'Notes'">

  <!-- header functions -->
  <sh-icon
    *ngIf="!isNoteFullscreen"
    slot="functions"
    icon="window-floating-undock"
    class="card-header-icon"
    button
    size="s"
    (click)="toggleNoteFullscreen()"
    (keydown)="toggleNoteFullscreen()">
  </sh-icon>
  <sh-icon
    *ngIf="isNoteFullscreen"
    slot="functions"
    icon="fullscreen-exit"
    class="card-header-icon"
    button
    size="s"
    (click)="toggleNoteFullscreen()"
    (keydown)="toggleNoteFullscreen()">
  </sh-icon>
  <sh-icon
    *ngIf="canDeleteGroupNotes"
    slot="functions"
    icon="delete"
    class="card-header-icon"
    button
    size="s"
    (click)="onDeleteGroupNotes()"
    (keydown)="onDeleteGroupNotes()">
  </sh-icon>
  <sh-icon
    slot="functions"
    icon="cancel"
    class="card-header-icon"
    button
    size="s"
    (click)="closeNoteCard()"
    (keydown)="closeNoteCard()">
  </sh-icon>

  <!-- card content -->
  <div class="card-content">

    <!-- notes list -->
    <div class="notes-list">
      <div *ngIf="isLoadingNotes" class="notes-empty">
        <sh-spinner size="s"></sh-spinner>
      </div>

      <div
        *ngIf="!isLoadingNotes && notes.length === 0"
        class="notes-empty">
        No notes yet.
      </div>

      <div
        *ngFor="let note of notes; trackBy: trackByNoteGuid"
        class="note-item">

        <div class="note-item-header">
          <div class="note-avatar">{{ getInitials(note.authorName) }}</div>
          <div class="note-author">{{ note.authorName }}</div>
          <div class="note-time" [id]="'note-time-' + groupIndex + '-' + note.guid">
            {{ getRelativeTime(note.modifiedDate || note.createdDate) }}
            <span *ngIf="note.isEdited">(edited)</span>
          </div>
          <sh-tooltip
            delay
            [target]="'note-time-' + groupIndex + '-' + note.guid"
            [label]="getExactTime(note.modifiedDate || note.createdDate)"
            placement="top"
            variation="short">
          </sh-tooltip>

          <sh-icon
            *ngIf="note.isOwner"
            icon="more"
            class="note-item-more"
            button
            size="s"
            [id]="'note-more-' + groupIndex + '-' + note.guid"
            (click)="toggleNoteMenu(note.guid)"
            (keydown)="toggleNoteMenu(note.guid)">
          </sh-icon>

          <sh-popover
            *ngIf="activeNoteMenuGuid === note.guid"
            [visible]="true"
            [target]="'note-more-' + groupIndex + '-' + note.guid"
            position="bottom-left"
            position-fixed-adjustment
            always-stay-within
            class="note-item-menu"
            style="z-index: 1200;">
            <sh-menu-item
              label="Edit"
              (click)="onEditNote(note)"
              (keydown)="onEditNote(note)">
            </sh-menu-item>
            <sh-divider></sh-divider>
            <sh-menu-item
              label="Delete"
              (click)="onDeleteNote(note)"
              (keydown)="onDeleteNote(note)">
            </sh-menu-item>
          </sh-popover>
        </div>

        <div class="note-item-content">{{ note.content }}</div>
      </div>
    </div>

    <!-- add / edit note input -->
    <div class="chat-input-container">
      <div
        class="chat-input"
        [class.no-box-shadow]="!showBoxShadow"
        [class.show-box-shadow]="showBoxShadow">
        <div class="chat-input-wrapper">
          <div class="input-field">
            <sh-input-text
              class="note-input"
              [value]="noteText"
              textarea
              rows="2"
              condensed
              no-border
              type="text"
              [label]="''"
              [placeholder]="editingNoteGuid ? 'Edit Note...' : 'Add Note...'"
              (value-changed)="onNoteTextChanged($event)"
              (keydown.enter)="onEnterPressed($event)">
            </sh-input-text>
          </div>

          <div class="chat-input-actions">
            <div class="right">
              <sh-button
                class="send-msg-btn"
                icon="plus"
                layout="normal"
                color="primary-neutral"
                size="auto"
                (click)="onSaveNote()"
                (keydown.enter)="onSaveNote()"
                [disabled]="disableSendButton()"
                onkeypress="return false;">
              </sh-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</sh-card>

<!-- Delete Group Notes Confirmation Modal -->
<sh-modal
  *ngIf="showDeleteNotesModal"
  [visible]="true"
  label="Delete Notes"
  modal-height="200px"
  modal-width="450px"
  style="z-index: 100020;"
  (modal-closed)="cancelDeleteGroupNotes()">

  <sh-text size="body">
    Are you sure you want to delete all notes for this group? This action cannot be undone.
  </sh-text>

  <div slot="footer" class="modal-footer-buttons">
    <sh-button
      color="secondary"
      label="Cancel"
      (click)="cancelDeleteGroupNotes()"
      (keydown.enter)="cancelDeleteGroupNotes()"
      [disabled]="isDeletingGroupNotes">
    </sh-button>
    <sh-button
      color="primary"
      [label]="isDeletingGroupNotes ? 'Deleting...' : 'Delete'"
      (click)="confirmDeleteGroupNotes()"
      (keydown.enter)="confirmDeleteGroupNotes()"
      [disabled]="isDeletingGroupNotes">
    </sh-button>
  </div>
</sh-modal>

</div>

